import Mock from 'mockjs'
import {baseUrl} from "../../api";

Mock.XHR.prototype.withCredentials = true
export default Mock.mock(RegExp(baseUrl + '/api/v1/loc-list.*'), 'get', {
        code: 200,
        message: "",
        "data": {
            "page": 0,
            "pageSize": 0,
            "count": 0,
            "total": 0,
            "rows|3-20":
                [
                    {
                        "id|+1": 1,
                        "createDt": "@datetime",
                        "boxNo|+1": "BOX000@increment()",
                        "trainNo|+1": "TRAIN000@increment()",
                        "trackNo|+1": "TRACK000@increment()",
                        "gpsNo|+1": "GPS000@increment()",
                        "20191220|": "@city",
                        "20191231|": "@city",
                        "20200102|": "@city",
                        "20200103|": "@city",
                        "20200104|": "@city",
                        "20200105|": "@city",
                        "20200107|": "@city",
                        "20200108|": "@city",
                        "20200109|": "@city",
                        "20200110|": "@city",
                        "20200111|": "@city",
                        "20200112|": "@city",
                        "20200113|": "@city",
                        "remarks":"123"
                    }
                ]
        }
    }
)